import StorageExhaustionError from '../StorageExhaustionError';
import { localStorageAdapter } from '../LocalStorageAdapter';
var SUBJECT = 'lti.put_data';
var handlePutData = function handlePutData(event, postMessageService) {
  var _event$data = event.data,
    key = _event$data.key,
    value = _event$data.value,
    message_id = _event$data.message_id;
  if (!key) {
    postMessageService.sendBadRequestErrorPostMessageResponse(SUBJECT, "Missing required 'key' field", event.source, event.origin);
    return true;
  }
  if (!message_id) {
    postMessageService.sendBadRequestErrorPostMessageResponse(SUBJECT, 'Missing required "message_id" field', event.source, event.origin);
    return true;
  }
  if (value) {
    try {
      localStorageAdapter.putData(event.origin, key, value);
      postMessageService.sendSuccessPostMessageResponse(SUBJECT, {
        key: key,
        value: value
      }, event.source, event.origin);
    } catch (e) {
      if (e instanceof StorageExhaustionError) {
        var code = e.code;
        var message = e.message;
        postMessageService.sendErrorPostMessageResponse(SUBJECT, message, code, event.source, event.origin);
      }
    }
  } else {
    localStorageAdapter.clearData(event.origin, key);
    postMessageService.sendResponse(SUBJECT, {
      key: key
    }, event.source, event.origin);
  }
};
export default handlePutData;